import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "about",
    templateUrl: "./about.component.html",
    standalone: false
})
export class AboutComponent implements OnInit {
    aboutText: string = "";
    constructor(private activatedRoute: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.aboutText = AuthService.businessFunction?.about || "";
    }
}